<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { REWARD } from '@/store/types';
import rewardApi from '@/services/apis/reward.api';

export default {
  props: {
    employer_id: { type: String, default: null },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = rewardApi.useExpiredCreditQuery({
      employer_id: props.employer_id,
    });
    if (query.value) {
      store.commit(REWARD.SET_EXPIRED_CREDIT_LIST_QUERY, query);
    }
    return { query };
  },
};
</script>
